import styled from 'styled-components'
import { Menu } from 'antd'

export const LogoutButton = styled(Menu)`
    && {
        margin-bottom: 16px;
    }
`
